<sjoborg-filter-list #conceptList [configService]="configService"></sjoborg-filter-list>
